export const environment = {
  production: true,
  loginForm: false,
  api: {
    host: 'https://api.fluidipricep.iasp.tgscloud.net',
    test: '',
  },
};
